import { GetFileType } from '@orbit/api-types'
import React, { useCallback, useEffect } from 'react'
import toast from 'react-hot-toast'
import {
	LightboxBackdrop,
	LightboxButton,
	LightboxClose,
	LightboxContainer,
	LightboxControls,
} from './AttachmentsViewerModal.styles'

interface LightboxProps {
	file: GetFileType | null
	onClose: () => void
}

const Lightbox: React.FC<LightboxProps> = ({ file, onClose }) => {
	const close = useCallback(() => onClose(), [onClose])

	useEffect(() => {
		if (!file) return
		const handleEsc = (e: KeyboardEvent) => {
			if (e.key === 'Escape') close()
		}
		document.addEventListener('keydown', handleEsc)
		return () => document.removeEventListener('keydown', handleEsc)
	}, [file, close])

	if (!file) return null

	const handleDownload = async () => {
		try {
			const response = await fetch(file.url)
			const blob = await response.blob()
			const link = document.createElement('a')
			link.href = URL.createObjectURL(blob)
			link.download = file.fileName
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)
			URL.revokeObjectURL(link.href)
		} catch {
			toast.error('Failed to download file')
		}
	}

	return (
		<LightboxBackdrop onClick={close}>
			<LightboxContainer onClick={e => e.stopPropagation()}>
				<LightboxClose onClick={close}>✕</LightboxClose>
				<img src={file.url} alt={file.fileName} />
				<LightboxControls>
					<LightboxButton onClick={handleDownload}>↓ Download</LightboxButton>
				</LightboxControls>
			</LightboxContainer>
		</LightboxBackdrop>
	)
}

export default Lightbox
